import { useSyncExternalStore } from 'react';

// Web half of useDocumentVisible (the native file reads AppState). Whether
// anyone can see the page: false while the tab is in the background or the
// window is minimised. Read straight from the document, so a visibility change
// rerenders only the components that ask, not every database consumer.
const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
};
const getSnapshot = () => document.visibilityState === 'visible';

// The server renders a visible page.
const getServerSnapshot = () => true;
const useDocumentVisible = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
export default useDocumentVisible;